import { useApps } from '@auth/useApps'
import { AppPermission } from '@shared/permissions'

/**
 * Centralizes the "Refine with AI" gating used across recognition, awards,
 * nominations, and card signing. `showRefineButton` is the convenience flag the
 * forms use to decide whether to render the button at all.
 */
const useCanRefineMessage = () => {
  const [hasAppPermission] = useApps()

  const canRefineMessage = hasAppPermission(
    'refinementApp',
    AppPermission.RefinementAppRefineMessage,
  )
  const canUpgradeLicense = hasAppPermission(
    'refinementApp',
    AppPermission.RefinementAppUpgradeLicense,
  )

  return {
    canRefineMessage,
    canUpgradeLicense,
    showRefineButton: canRefineMessage || canUpgradeLicense,
  }
}

export default useCanRefineMessage
